import AnalyticsStore from '@/core/analytics/store';
import AssetStore from '@/core/assets/AssetStore';
import CampaignsStore from '@/campaigns/store';
import CharacterStore from '@/characters/store';
import CollectionStore from '@/core/collections/store';
import DrawingStore from '@/core/drawing/store';
import DropperStore from '@/core/dropper/store/DropperStore';
import EditStore from '@/store/EditStore';
import ErrorStore from '@/core/errors/store';
import HasPermissionStore from '@/core/permissions/gm/hasPermissionFor';
import GameStateStore from '@/store/GameStateStore';
import GmPermissionsStore from '@/core/permissions/gm/store';
import GridStore from '@/core/grid/store';
import FogStore from '@/core/fog/store';
import HotbarPinStore from '@/characters/hotbar/store';
import InitiativeStore from '@/table/initiative/store';
import KeyboardStore from '@/core/events/keyboard/store';
import LibraryStore from '@/core/library/store/LibraryStore';
import LivePlayState from '@/core/live/LivePlayState';
import NotificationStore from '@/core/notifications/store';
import PlayerStore from '@/core/collections/players/store';
import TemplateStore from '@/core/collections/templates/store';
import TokenStore from '@/core/collections/tokens/store';
import UserCollectionStore from '@/core/collections/user/UserCollectionStore';
import ProfileStore from '@/profile/store';
import WindowStore from '@/core/events/window/store';
import { createStore } from 'vuex';
import { oidcSettings } from './oidc';
import { vuexOidcCreateStoreModule } from 'vuex-oidc';
import logger from '@/app/logger';

const store = createStore({
    modules: {
        live: LivePlayState,
        gamestate: GameStateStore,
        oidcStore: vuexOidcCreateStoreModule(
            oidcSettings as any,
            {
                dispatchEventsOnWindow: true,
            },
            {
                userLoaded: (user: any) => {
                    logger.debug('OIDC user is loaded:', logger.sensitive(user));
                    (window as any)._paq.push(['setUserId', user.profile.email]);
                },
                userUnloaded: () => {
                    logger.debug('OIDC user is unloaded');
                },
                accessTokenExpiring: () => {
                    logger.debug('Access token will expire');
                },
                accessTokenExpired: () => {
                    logger.debug('Access token did expire');
                },
                silentRenewError: () => {
                    logger.debug('Silent renew error');
                },
                userSignedOut: () => {
                    logger.debug('OIDC user is signed out');
                },
                oidcError: (payload: any) => {
                    logger.debug(`An error occured at ${payload.context}:`, payload.error);
                },
            },
        ),
        assets: AssetStore,
        dropper: DropperStore,
        library: LibraryStore,
        collections: CollectionStore,
        userCollections: UserCollectionStore,
        campaigns: CampaignsStore,
        players: PlayerStore,
        characters: CharacterStore,
        templates: TemplateStore,
        tokens: TokenStore,
        drawing: DrawingStore,
        grid: GridStore,
        fog: FogStore,
        gmPermissions: GmPermissionsStore,
        hasPermission: HasPermissionStore,
        profile: ProfileStore,
        keyboard: KeyboardStore,
        window: WindowStore,
        analytics: AnalyticsStore,
        errors: ErrorStore,
        notifications: NotificationStore,
        editingModes: EditStore,
        hotbarPin: HotbarPinStore,
        initiative: InitiativeStore,
    },
});

export default store;
